<template>
    <div class="user-agreement">
      <h1>用户协议</h1>
      <section>
        <h2>一、接受条款</h2>
        <p>
          通过访问或使用本应用程序，您表示您已阅读、理解并同意受本协议的约束。本协议适用于所有使用本应用程序的用户。
        </p>
      </section>
  
      <section>
        <h2>二、隐私政策</h2>
        <p>
          我们重视您的隐私，并承诺保护您的个人信息。请参阅我们的隐私政策，以了解我们如何收集、使用和保护您的信息。通过使用本应用程序，您同意我们按照隐私政策的规定处理您的信息。
        </p>
      </section>
  
      <section>
        <h2>三、使用规则</h2>
        <ul>
          <li>您应对使用本应用程序的行为负责，不得用于任何非法或不正当的目的。</li>
          <li>您不得干扰或破坏本应用程序的正常运行，包括但不限于传播病毒、垃圾邮件、或其他有害代码。</li>
          <li>您不得试图未经授权访问本应用程序的任何部分或功能，或连接到本应用程序的任何服务器或网络。</li>
        </ul>
      </section>
  
      <section>
        <h2>四、用户内容</h2>
        <ul>
          <li>您在本应用程序中发布的内容（包括但不限于图片、视频等）应遵守相关法律法规，不得侵犯他人的合法权益。</li>
          <li>您同意授予我们在全球范围内的、免费的、非独占的、可转让的许可，以使用、复制、修改、发布和展示您的用户内容。</li>
        </ul>
      </section>
  
      <section>
        <h2>五、知识产权</h2>
        <ul>
          <li>本应用程序及其所有内容（包括但不限于文本、图像、标志、图标、软件等）均受版权、商标和其他相关法律的保护。</li>
          <li>未经我们或相关权利人事先书面同意，您不得以任何方式使用本应用程序的任何内容。</li>
        </ul>
      </section>
  
      <section>
        <h2>六、免责声明</h2>
        <ul>
          <li>本应用程序按“现状”提供，我们不对其适用性、可靠性、可用性、及时性、准确性和完整性作出任何明示或暗示的保证。</li>
          <li>在法律允许的范围内，我们不对因使用或无法使用本应用程序而导致的任何直接、间接、附带、特殊、后果性或惩罚性的损害承担责任。</li>
        </ul>
      </section>
  
      <section>
        <h2>七、修改和终止</h2>
        <ul>
          <li>我们保留在任何时候修改或终止本应用程序及本协议的权利。修改后的协议将通过本应用程序通知您，并自发布之日起生效。</li>
          <li>如果您不同意修改后的协议，请立即停止使用本应用程序。您继续使用本应用程序将被视为您接受修改后的协议。</li>
        </ul>
      </section>
  
      <section>
        <h2>八、适用法律</h2>
        <p>
          本协议受中华人民共和国法律管辖，不考虑其冲突法原则。因本协议引起的或与本协议有关的任何争议应提交至我们所在地的有管辖权的人民法院解决。
        </p>
      </section>
  
      <section>
        <h2>九、联系信息</h2>
        <p>如您对本协议有任何疑问，请通过以下方式联系我们：</p>
        <p>电子邮件：chuliukj88@163.com</p>
      </section>
    </div>
  </template>
  
  <script>
  export default {
    name: "UserAgreement",
  };
  </script>
  
  <style scoped>
  .user-agreement {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
    line-height: 1.6;
    text-align: left;
  }
  
  .user-agreement h1 {
    text-align: center;
    margin-bottom: 20px;
    color: #333;
  }
  
  .user-agreement h2 {
    color: #007BFF;
    margin-top: 20px;
  }
  
  .user-agreement p, .user-agreement ul {
    margin-bottom: 20px;
  }
  
  .user-agreement ul {
    padding-left: 20px;
  }
  
  .user-agreement ul li {
    list-style-type: disc;
  }
  </style>
  